import { CardElement, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Card } from "../../components/card.component";
import { Button } from "../../components/button.component";

const stripePromise = loadStripe(
  "pk_test_51KQUXjLJ4LmMw71Nd6ZlXbvZw6UKv5rrhoEeLZItx9eNboJ3RG31toPGlWo3mLnccGN8CNwFB30wRxlHJ0hUYclS00ITkw5jXQ"
);

export const PageCheckout = () => {
  const options = {
    // passing the client secret obtained from the server
    // clientSecret:
    //   "sk_test_51KQUXjLJ4LmMw71N0QAYSVf63SAVQ6hGvFWCCSDKBYj7K0qy0bQcsZU0xzopO7m9qNMBRvyB85sIABcWmpZXqPG400pzTP4iLk",
  };

  return (
    <Card
      header={
        <div className="row align-items-center  justify-content-between">
          <div className="col content-box-title">
            <div>
              <p className="text-capitalize mb-0 text-green-200">Checkout</p>
            </div>
            <div className="collapse-icon"></div>
          </div>
        </div>
      }
    >
      <Elements stripe={stripePromise} options={options}>
        <form className="container my-5">
          <CardElement />
          <Button name={"Submit"} className="mt-3 btn btn-green" />
        </form>
      </Elements>
    </Card>
  );
};
